import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import SelfAssessmentCard from 'components/organisms/assessments/SelfAssessmentCard'
import SelfAssessmentReport from 'components/molecules/assessments/SelfAssessmentReport'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import LeftPanelTemplate from 'components/templates/LeftPanelTemplate'
import LeftPanelTitle from 'components/atoms/container/LeftPanelTitle'
import { getLocalUser } from 'utils/localStorage'
import { useTranslation } from 'react-i18next'
import { getGoalInfoById } from 'utils/getSupportingInfo'
import { desctructUser } from 'utils/formatText'

const AssessmentSelf = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const [firstName, ,] = desctructUser(getLocalUser())
  const goalId = location.state?.goalId
  const firstTime = location.state?.firstTime
  const isCurrentGoal = location.state?.currentGoal
  const cohortUser = location.state?.cohortUser

  const [goal, setGoal] = useState(null)
  const [showResults, setShowResults] = useState(false)
  const [assessmentResultData, setAssessmentResultData] = useState({})

  useEffect(() => {
    const fetchGoalData = async () => {
      if (goalId) {
        const goal = await getGoalInfoById(goalId)
        if (goal) {
          setGoal(goal)
        }
      }
    }
    fetchGoalData()
  }, [goalId])

  return (
    <HomePage customizedBodyWidth={true}>
      <LeftPanelTemplate
        titleGroup={
          <LeftPanelTitle
            title={t('onboarding.selfAssessment3.greetings')}
            superText={`Hi, ${firstName}`}
            subText={goal?.name}
          />
        }>
        {!showResults ? (
          <SelfAssessmentCard
            goalId={goalId}
            showLandingPopup={firstTime || isCurrentGoal}
            cohortUser={cohortUser}
            setResultData={setAssessmentResultData}
            nextStepCallback={() => {
              setShowResults(true)
            }}
          />
        ) : (
          <SelfAssessmentReport
            resultData={assessmentResultData}
            disableBehaviorClick={true}
            fromSelfAssessment={true}
          />
        )}
      </LeftPanelTemplate>
    </HomePage>
  )
}

export default AssessmentSelf
